interface EmailTemplatePreviewFrameProps {
    bodyHtml: string;
}

/** Renders full branded email HTML (header + CTA already in template body). */
export function EmailTemplatePreviewFrame({ bodyHtml }: EmailTemplatePreviewFrameProps) {
    return (
        <div className="overflow-x-auto rounded-lg border border-subtle bg-[#F7F7FB] shadow-sm">
            <div
                className="max-w-none min-w-0 [&_a]:no-underline [&_img]:max-w-full [&_table]:max-w-full"
                dangerouslySetInnerHTML={{ __html: bodyHtml }}
            />
        </div>
    );
}
